import React from 'react'
import PropTypes from 'prop-types'
import IAction from './IAction'
import UUID from 'uuid'
const $ = window.$

class Notif extends IAction {
    constructor(props) {
        super(props)
        this.state = { key: UUID.v4() }
    }

    componentDidMount() {
        $(`.dropdown-button.${this.state.key}`).dropdown()
    }

    fn = () => this.props.onClick

    icon = () => this.props.icon

    label = () => this.props.label || this.title()

    title = () => this.props.title

    getColor() {
        return this.props.color ? { backgroundColor: this.props.color } : {}
    }

    notifs() {
        if (this.props.notifs > 0) {
            return <span className='new badge' style={ this.getColor() }>{ this.props.notifs }</span>
        }
        return null
    }

    dropdown() {
        return (
            <div className={ `dropdown-content row no-margin ${this.state.key}`} id={ this.title() }>
                <div className='col s12 no-padding title'>
                    <h6 className='center-align'>
                        <b>{ this.label() }</b>
                    </h6>
                    <p className='no-margin no-padding divider'/>
                </div>
                <div className='col s12 no-padding'>
                    {this.props.content}
                </div>
            </div>
        )
    }
}

Notif.propTypes = {
    onClick: PropTypes.func,
    icon: PropTypes.string.isRequired,
    label: PropTypes.string,
    color: PropTypes.string,
    content: PropTypes.element,
    notifs: PropTypes.number
}

Notif.defaultProps = {
    onClick: () => {},
    icon: 'ICON Not specified',
    label: '',
    color: '',
    content: '',
    notifs: 0
}

export default Notif



// WEBPACK FOOTER //
// ./src/components/actions/Notif.js